const VIRTUAL_OUTBOUND_CHANNELS = new Set(["internal_note", "personal_whatsapp"]);

export function parseBlockedOutboundChannelIds(raw) {
  if (raw == null || raw === "") return [];
  let value = raw;
  if (typeof raw === "string") {
    try {
      value = JSON.parse(raw);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(value)) return [];
  return [...new Set(value.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0))];
}

export function isOutboundChannelUnrestricted(blockedIds, { isMaster = false } = {}) {
  if (isMaster) return true;
  return blockedIds == null;
}

export function isOutboundChannelIdBlocked(channelId, blockedIds, { isMaster = false } = {}) {
  if (isOutboundChannelUnrestricted(blockedIds, { isMaster })) return false;
  if (channelId == null || channelId === "") return false;
  if (VIRTUAL_OUTBOUND_CHANNELS.has(String(channelId).trim())) return false;
  const id = Number(channelId);
  if (!Number.isFinite(id) || id <= 0) return false;
  return parseBlockedOutboundChannelIds(blockedIds).includes(id);
}

export function filterChannelsNotBlocked(channels, blockedIds, { isMaster = false } = {}) {
  if (!Array.isArray(channels)) return [];
  if (isOutboundChannelUnrestricted(blockedIds, { isMaster })) return channels;
  const blocked = new Set(parseBlockedOutboundChannelIds(blockedIds));
  if (!blocked.size) return channels;
  return channels.filter((ch) => {
    const id = Number(ch?.id ?? ch?.value);
    if (!Number.isFinite(id) || id <= 0) return true;
    return !blocked.has(id);
  });
}
